import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroupDirective, Validators } from '@angular/forms';
import { NewCaseApprovalService } from '../../service/new-case-approval/new-case-approval.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { GenderEnum } from 'src/app/utility/enum/gender.enum';
import { PpoBalanceService } from '../../service/ppo-balance/ppo-balance.service';
import { ActivatedRoute } from '@angular/router';
import { PpoListService } from '../../service/ppo-list/ppo-list.service';
import { NavigateService } from 'src/app/utility/services/navigate/navigate.service';
import { productCodes, maternityBenefits, ResponseMessageStatus, PPORequestStatus } from "../../../../utility/enum/global-enum";
import { EnumService } from 'src/app/utility/services/enum-service/enum.service';
import { OtpMessage } from '../../model/otpMessage';
import { ResponseMessage } from '../../model/response-message';
import { OtpService } from '../../service/otp/otp.service';
import { AlphanumericValidator } from 'src/app/utility/validator/alphanumeric.validator';
import { FileHandlerService } from 'src/app/utility/services/file-handler/file-handler.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-new-case-approval',
  templateUrl: './new-case-approval.component.html',
  styleUrls: ['./new-case-approval.component.scss']
})
export class NewCaseApprovalComponent implements OnInit {

  dataRequiredForDocumentUpload: any;
  isDocumentUploadPage: boolean;
  groupPolicyId: number;
  selectedPolicyNumber: string;
  enrolId: number;
  insuredName: string;
  benefitId: number;

  isAnyInitiativeTaken = false;
  isSearchShow = true;
  isFullFormShow = false;
  isDiseaseControlShow = false;
  isBalanceButtonShow = false;
  isBalanceShow = false;
  isPregnantCheckboxShow = false;
  isPreApprovedDataEntryMode = false;
  isDeliveryTypeControlShow = false;
  isOpProduct: boolean = false;

  policyInfos = [];
  enrolProducts = [];
  dependentProducts = [];
  relationList = [];
  diseaseList = [];
  productList = [];
  balanceList = [];
  deliveryTypes = [];
  enrol: any;

  ppoRequestId: number;
  previousHospitalName: string;
  exceedAmountMessage: string;
  inclusion:string[] = [];
  exclusion:string[] = [];
  today = new Date();
  enumService: any;

  isValidBalanceList: boolean = true;
  isServiceDate: boolean = false;
  isOtpGenerate = false;
  otpFlag = false;
  timeLeft = 120;
  subscribeTimer: any;
  hashMobileNumber: string;
  customMessage = new OtpMessage();

  otpFromDirective: FormGroupDirective;
  validatePolicyFromDirective: FormGroupDirective;
  mobileNumber: string;
  otpBtnDisabled = false;
  filteredOptions: Observable<string[]>;

  constructor(
    private fb: FormBuilder,
    private activateRoute: ActivatedRoute,
    private newCaseApprovalService: NewCaseApprovalService,
    private ppoBalanceService: PpoBalanceService,
    private ppoService: PpoListService,
    private messageService: MessageService,
    private navigationService: NavigateService,
    private enumDataService: EnumService,
    private otpService: OtpService,
    private fileHandlerService: FileHandlerService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.today.setDate(this.today.getDate());
  }

  validatingEnrolFrom = this.fb.group({
    groupPolicyNumber: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9]*$')]],
    certificateNo: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9-]*$')]],
    birthYear: [null, [Validators.required, Validators.minLength(4), Validators.pattern('^[0-9]{4}$')]],
  });

  diseaseDetailForm = this.fb.group({
    relationId: [0, [Validators.required]],
    productId: [null, [Validators.required]],
    admissionDate: [null, [Validators.required]],
    diseaseId: [null],
    isPregnant: [false],
    dischargeDate: [null],
    deliveryType: [null],
    patientId: [null, [Validators.maxLength(20), AlphanumericValidator]]
  });

  otpForm = this.fb.group({
    otp: new FormControl(null, [Validators.required])
  });

  ngOnInit() {
    this.setPolicySubscriber();
    this.loadDeliveryTypes();
    this.ppoRequestId = Number(this.activateRoute.snapshot.paramMap.get('id'));
    if (this.ppoRequestId) {
      this.ppoService.getPpoRequestDetails(this.ppoRequestId)
        .subscribe(res => {
          this.dataRequiredForDocumentUpload = res;

          if(res.statusId != PPORequestStatus.Initialized) {
            this.isAnyInitiativeTaken = true;
          }

          /* year and search button hide, patient info form show */
          this.groupPolicyId = res.groupPolicyId;
          this.isSearchShow = false;
          this.isFullFormShow = true;
          this.isPreApprovedDataEntryMode = true;
          this.isBalanceShow = true;

          /* value set search form */
          this.validatingEnrolFrom.patchValue({
            groupPolicyNumber: res.policyNumber,
            certificateNo: res.certificateNumber,
            birthYear: res.birthYear
          });

          /* get relation info data */
          this.getInformation();
          const relationObj = this.relationList.find(x => x.enrolDependentId == res.dependentId);
          const relationId = relationObj ? relationObj.relationId : 0;

          this.diseaseDetailForm.patchValue({
            relationId,
            productId: res.productId,
            diseaseId: res.diseaseId,
            admissionDate: res.admissionDate,
            isPregnant: res.isPregnant,
            deliveryType: res.deliveryType,
            dischargeDate: res.dischargeDate,
            patientId: res.patientId,
          });

          this.diseaseDetailForm.get('diseaseId').disable();
          this.diseaseDetailForm.get('admissionDate').disable();
          this.diseaseDetailForm.get('isPregnant').disable();
          this.diseaseDetailForm.get('patientId').disable();

          if(this.isAnyInitiativeTaken) {
            this.diseaseDetailForm.disable();
          }

        });
      this.ppoService.getLastHospitalWithPendingBalance(this.ppoRequestId)
        .subscribe(res => this.previousHospitalName = res);
      this.loadBalanceInfo(this.ppoRequestId);
    }

    this.diseaseDetailForm.get('productId').valueChanges.subscribe(() => {
      this.updateServiceDate();
    });

    this.filteredOptions = this.diseaseDetailForm.get('diseaseId').valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );

  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  loadDeliveryTypes() {
    this.enumDataService.getMaternityDeliveryTypes().subscribe(res => {
      res.forEach(e => {
        if (e.id != maternityBenefits.WillfulTermination.id) {
          this.deliveryTypes.push(e);
        }
      });
    });
  }

  setPolicySubscriber() {
    this.validatingEnrolFrom.get('groupPolicyNumber').valueChanges
      .pipe(debounceTime(500)).subscribe(value => {
        if (value && value != this.selectedPolicyNumber) {
          this.newCaseApprovalService.searchPolicy(value).subscribe(res => {
            this.policyInfos = res;
          });
        }
      });
  }

  setGroupName() {
    const { groupPolicyNumber } = this.validatingEnrolFrom.value;
    this.selectedPolicyNumber = groupPolicyNumber;
    this.policyInfos.forEach(element => {
      if (element.groupNumber == groupPolicyNumber) {
        this.groupPolicyId = element.id;
      }
    });
  }

  validateForm() {
    const { groupPolicyNumber, certificateNo, birthYear } = this.validatingEnrolFrom.value;
    return groupPolicyNumber && certificateNo && birthYear ? true : false;
  }

  IsValidDiseaseForm() {
    const { productId, diseaseId } = this.diseaseDetailForm.value;
    const product = this.productList.find(e => e.id == productId);

    if (product && product.code == productCodes.IP && !diseaseId) {
      return false;
    }
    return true;
  }

  getInsuredName() {
    return this.insuredName;
  }

  getInformation() {
    const { certificateNo, birthYear } = this.validatingEnrolFrom.getRawValue();
    this.newCaseApprovalService.getEnrol(this.groupPolicyId, certificateNo, birthYear)
      .subscribe(enrol => {
        if (enrol != null) {
          this.enrol = enrol;
          this.enrolId = enrol.id;
          this.newCaseApprovalService.getEnrolInformation(this.enrolId).subscribe(res => {

            this.isSearchShow = false;
            this.isFullFormShow = true;

            this.insuredName = res.data.insureName;
            this.enrolProducts = res.data.enrolProducts;
            this.dependentProducts = res.data.dependentProducts;
            this.relationList = res.data.relations;

            this.dependentChange();
            this.validatingEnrolFrom.disable();

          }, err => {
            this.messageService.show(err.error.message, "error");
          });
        }
      }, err => {
        this.messageService.show(err.error.message, "error");
      });
  }

  loadDisease() {
    if (this.diseaseList && this.diseaseList.length < 1) {
      this.newCaseApprovalService.getDiseases().subscribe(res => {
        this.diseaseList = res;
      }, err => {
        this.messageService.show(err.error.message, "error");
      });
    }
  }

  dependentChange() {
    this.isDiseaseControlShow = false;
    this.isPregnantCheckboxShow = false;
    this.isDeliveryTypeControlShow = false;

    if (!this.isPreApprovedDataEntryMode) {
      this.diseaseDetailForm.get('productId').reset();
      this.diseaseDetailForm.get('diseaseId').reset();
      this.diseaseDetailForm.get('deliveryType').reset();
    }

    const { relationId } = this.diseaseDetailForm.value;

    if (!relationId) {
        this.productList = [...this.enrolProducts];
        if (this.enrol.gender == GenderEnum.Male) {
          const index = this.productList.findIndex(e => e.code == productCodes.Maternity);
          if (index >= 0) {
            this.productList.splice(index, 1);
          }
        }
    } else {
      const relation = this.relationList.find(e => e.enrolDependentId == relationId);
      const dependentProd = [];
      if (relation != null && relation.relationName.toLowerCase() == "wife") {
        this.dependentProducts.forEach(element => {
          if (element.dependantId == relationId) {
            dependentProd.push(element);
          }
        });
        this.productList = dependentProd;
      } else {
        this.dependentProducts.forEach(element => {
          if (element.dependantId == relationId && element.code != productCodes.Maternity) {
            dependentProd.push(element);
          }
        });
        this.productList = dependentProd;
      }
    }
    if (this.isPreApprovedDataEntryMode) {
      this.diseaseDetailForm.get('relationId').disable();
    }
    this.productChange();
  }


  productChange() {
    const { productId } = this.diseaseDetailForm.value;
    const product = this.productList.find(e => e.id == productId);
    const { relationId } = this.diseaseDetailForm.value;
    const patient = relationId > 0 ? this.relationList.find(e => e.enrolDependentId == relationId) : this.enrol;

    // toggle disease and isPregnant control for IP & Out_Patient(Per Disability)
    if (!productId) {
      // Nothing to do
    } else if (product &&
      (product.code == productCodes.IP ||
        product.code == productCodes.IP_YEARLY ||
        product.code == productCodes.IP_FIELD_FORCE ||
        product.code == productCodes.OutPatient_OP ||
        product.code == productCodes.OutPatient_Per_Disability ||
        product.code == productCodes.IP_YEARLY_WITHOUT_MATERNITY)
    ) {
      if (product.code == productCodes.OutPatient_OP || product.code == productCodes.OutPatient_Per_Disability) {
        this.isOpProduct = true;
        this.diseaseDetailForm.get('admissionDate').setValue(this.getCurrentDate());
        this.isPregnantCheckboxShow = false;
      }

      if (product.code != productCodes.OutPatient_OP) {
        this.diseaseControlChange(patient);
      } else {
        this.isDiseaseControlShow = false;
      }

    }
    else {
      this.isDiseaseControlShow = false;
      this.isPregnantCheckboxShow = false;
      this.isDeliveryTypeControlShow = true;

      if (this.ppoRequestId > 0 && this.isPreApprovedDataEntryMode) {

        const { deliveryType } = this.diseaseDetailForm.getRawValue();
        if (deliveryType == maternityBenefits.LegalAbortion.id) {
          this.diseaseDetailForm.get('deliveryType').disable();
        } else {
          const index = this.deliveryTypes
            .findIndex(x => x.id == maternityBenefits.LegalAbortion.id);
          if (index > -1) {
            this.deliveryTypes.splice(index, 1);
          }
        }
      }
    }

    if (this.isPreApprovedDataEntryMode) {
      this.diseaseDetailForm.get('productId').disable();
    } else {
      this.resetEligibilityAndShowBalance();
    }
  }

  diseaseControlChange(patient: any) {

    const femaleArray = ['daughter', 'wife', 'mother'];
    this.loadDisease();
    this.isDiseaseControlShow = true;
    this.isDeliveryTypeControlShow = false;
    if (patient && patient.gender == GenderEnum.Female || (femaleArray.includes(patient.hasOwnProperty('relationName') && patient.relationName.toLowerCase()))) {
      this.isPregnantCheckboxShow = true;
    } else {
      this.isPregnantCheckboxShow = false;
    }
  }

  resetForm() {
    this.insuredName = '';

    this.isSearchShow = true;
    this.isFullFormShow = false;
    this.isDiseaseControlShow = false;
    this.isBalanceButtonShow = false;
    this.isBalanceShow = false;
    this.isPregnantCheckboxShow = false;
    this.isPreApprovedDataEntryMode = false;
    this.isDeliveryTypeControlShow = false;

    this.enrolProducts = [];
    this.dependentProducts = [];
    this.relationList = [];
    this.productList = [];

    this.validatingEnrolFrom.enable();
    this.diseaseDetailForm.reset();
  }

  showBalance() {
    this.isBalanceShow = true;
    this.loadBalanceInfo(this.ppoRequestId);
    this.ppoService.getLastHospitalWithPendingBalance(this.ppoRequestId)
      .subscribe(res => this.previousHospitalName = res);
  }

  resetEligibilityAndShowBalance() {
    this.ppoRequestId = null;
    this.isBalanceShow = false;
    this.isBalanceButtonShow = false;
  }

  runEligibility() {
    const entity = this.diseaseDetailForm.value;
    const obj = this.createEntityObj(entity);
    this.newCaseApprovalService.runEligibility(obj).subscribe(res => {
      if (res.data > 0) {
        this.ppoRequestId = res.data;
        this.isBalanceButtonShow = true;
      } else {
        this.messageService.show(res.msg, "error");
      }
    }, err => {
      this.messageService.show(err.error.message, "error");
    });
  }

  generateLetter = (): void => {
    this.newCaseApprovalService.generatePreApprovalLetter(this.ppoRequestId).subscribe(
      (res: any) => {
        this.fileHandlerService.downloadPdf(res, 'Pre Approval Letter.pdf');
        this.messageService.show("Letter generated successfully!", "success");
      },
      (err: any) => {
        this.messageService.show(err.error.message, "error");
      }
    );
  }

  createEntityObj(entity) {
    return {
      groupPolicyId: this.groupPolicyId,
      enrolId: this.enrol.id,
      dependentId: entity.relationId > 0 ? entity.relationId : null,
      productId: entity.productId,
      admissionDateTime: entity.admissionDate,
      diseaseId: entity.diseaseId,
      gPClusterId: this.enrol.groupPolicyClusterId,
      isPregnant: entity.isPregnant,
      deliveryType: entity.deliveryType,
      patientId: entity.patientId,
    };
  }

  loadBalanceInfo(id: number) {
    this.ppoBalanceService.getPpoDiscount(id)
      .subscribe(res => {

        this.balanceList = res;
        this.balanceList.filter(x => x.subBenefitId === null).forEach(x => x.isValid = true);
        const exclusions = this.balanceList.map(balance => balance.exclusion);
        this.exclusion = this.filterDuplicate(exclusions);

        const inclusions = this.balanceList.map(balance => balance.inclusion);
        this.inclusion = this.filterDuplicate(inclusions);
      });
  }

  onChangeAmount(balance, $event, type, index) {
    let value = $event.target.value;
    this.checkBalanceAmountAndDiscounts(balance, value, type, index);
  }

  checkBalanceAmountAndDiscounts(balance, value, type, index){
    if (type === 'amount') {
      balance.amount = Math.abs(Number(value));
      balance.coInsuranceAmount = (Number((balance.amount * balance.coInsurance) / 100)).toFixed(2);

      if (!balance.discount)
        balance.discount = 0;
    }
    else {
      balance.discount = Math.abs(Number(value));
      if (!balance.amount) {
        balance.amount = 0;
        balance.coInsuranceAmount = 0;
      }
    }

    balance.netAmount = (balance.amount - balance.discount - balance.coInsuranceAmount).toFixed(2);

    if (balance.amount > balance.aproxAvailableAmount) {
      this.balanceList[index].isValid = false;
      this.exceedAmountMessage = `
        ${balance.headName} claim amount <strong> ${balance.amount} </strong>
        must be less than approximate available amount <strong> ${balance.aproxAvailableAmount} </strong>.`
    }
    else if (balance.discount > (balance.amount - balance.coInsuranceAmount)){
      this.balanceList[index].isValid = false;
      this.exceedAmountMessage = `
        ${balance.headName} discount amount <strong> ${balance.discount} </strong>
        must be less than amount <strong> ${balance.amount - balance.coInsuranceAmount} </strong>.`
    }
    else if (balance.netAmount < 0) {
      this.balanceList[index].isValid = false;
      this.exceedAmountMessage = `
        ${balance.headName} net amount <strong> ${balance.netAmount} </strong>
        must be greater than <strong> 0 </strong>.`
    }
    else {
      this.exceedAmountMessage = null;
      this.balanceList[index].isValid = true;
    }
    this.checkBalanceListValidity();
  }

  checkBalanceListValidity() {

    this.isValidBalanceList = !this.balanceList.some(x => x.isValid == false);

    if(!this.isValidBalanceList && this.exceedAmountMessage == null){
      let invalidBalance = this.balanceList.filter(x => x.isValid == false)[0];
      this.checkBalanceAmountAndDiscounts(
        invalidBalance,invalidBalance.amount,
        'amount',
        this.balanceList.findIndex(a => a.benefitId == invalidBalance.benefitId && a.subBenefitId == invalidBalance.subBenefitId))
    }

    const onlybenefits = this.balanceList.filter(x => x.subBenefitId == null);
    const isPlanMaxIncluded: boolean = this.balanceList.some(x => x.withProduct);

    if (isPlanMaxIncluded) {
      const claimAmount = onlybenefits.reduce((accumulator, item) => accumulator + item.amount, 0);
      const remainingPlanMax = this.balanceList.find(x => x.withProduct).remainingBalance;

      if (claimAmount > remainingPlanMax) {
        this.isValidBalanceList = false;
        const benefitNames = onlybenefits.map(u => u.benefitName).join(", ");
        this.exceedAmountMessage = this.exceedAmountMessage == null ? `Total claim amount <strong>${claimAmount}</strong> of (${benefitNames}) must be less than total Remaining Plan Max amount <strong>${remainingPlanMax}</strong>.` : this.exceedAmountMessage;
      }
    }

    for (let item of onlybenefits) {
      const subBenefits = this.balanceList.filter(x => x.benefitId == item.benefitId && x.subBenefitId != null);
      const totalSubBenefitAmount = subBenefits.reduce((accumulator, item) => accumulator + item.amount, 0);

      if(item.subBenefitId === null && subBenefits.length === 0){
        break;
      }

      if (totalSubBenefitAmount > item.amount) {
        this.isValidBalanceList = false;
        const subBenefitNames = subBenefits.map(u => u.subBenefitName).join(", ");
        this.exceedAmountMessage = this.exceedAmountMessage == null ?
          `Total sum amount <strong>${totalSubBenefitAmount}</strong> of sub benefits <strong>(${subBenefitNames})</strong> must be less than total remaining benefit amount <strong>
                                ${item.amount == null ? 0 : item.amount} of ${item.benefitName}</strong>.` : this.exceedAmountMessage;
        break;
      }

      if (item.amount > 0 && (totalSubBenefitAmount == null || totalSubBenefitAmount <= 0 || totalSubBenefitAmount > item.amount)) {
        this.isValidBalanceList = false;
        this.exceedAmountMessage = "Without adding amount in sub benefit, benefit amount field will not be editable.So please add any of one";
        break;
      }

      if (item.amount == 0 && totalSubBenefitAmount > 0) {
        this.isValidBalanceList = false;
        this.exceedAmountMessage = "Without adding amount in sub benefit, benefit amount field will not be editable.So please add any of one";
        break;
      }
    };

    if (!this.isValidBalanceList && this.exceedAmountMessage == null) {
      this.exceedAmountMessage = `Invalid amount found in the list. Please check`;
    }

  }

  onNext() {
    if(this.isPreApprovedDataEntryMode){
      this.ppoBalanceService.saveAmount(this.balanceList).subscribe(res => { });
      const { dischargeDate, deliveryType } = this.diseaseDetailForm.value;
      this.ppoService.edit({ id: this.ppoRequestId, dischargeDate, deliveryType }).subscribe(res => {

        let benefits = this.balanceList.filter(x => x.subBenefitId == null);
        this.dataRequiredForDocumentUpload.claimAmount = benefits.reduce((accumulator, value) => accumulator + value.amount, 0);
        this.dataRequiredForDocumentUpload.benefitTotalNetAmount =
          benefits.reduce((accumulator, value) => accumulator + parseFloat(value.netAmount || 0), 0);

        this.isDocumentUploadPage = true;
        this.generateLetter();
      });
    }else{
      this.navigationService.toPpoPreApprovedBillEntry(this.ppoRequestId);
    }
  }

  filterDuplicate(items: string[]) {
    let individualItems = [];
    items.map(function(value){
      if(value){
        let splitedItems = value.split(',').map(function(val){ return val.trim()});
        individualItems = individualItems.concat(splitedItems);
      }
    });

    return [... new Set(individualItems)];
  }

  getBenefitId() {
    const { deliveryType } = this.diseaseDetailForm.value;
    let benefitId;
    for (const key in maternityBenefits) {
      if (maternityBenefits[key].id == deliveryType) {
        benefitId = maternityBenefits[key].benefitId;
      }
    }
    return benefitId;
  }

  updateServiceDate() {
    const productId = this.diseaseDetailForm.get('productId').value;
    const product = this.productList.find(e => e.id == productId);

    if (product && (product.code == productCodes.OutPatient_Per_Disability || product.code == productCodes.OutPatient_OP)) {
      this.isServiceDate = true;
    }
    else {
      this.isServiceDate = false;
    }
  }

  genarateOTP(formDirective: FormGroupDirective) {
    this.validatePolicyFromDirective = formDirective;
    this.otpBtnDisabled = !this.otpBtnDisabled;
    this.otpFlag = false;
    const entity = this.validatingEnrolFrom.value;
    this.getMobileNumber(entity);

  }

  startTimer() {
    this.subscribeTimer = setInterval(() => {
      this.timeLeft--;
      if (this.timeLeft == 0) {
        this.clearTimer();
        this.otpFlag = false;
        this.timeLeft = this.customMessage.otpLeftTime;
        this.isOtpGenerate = false;
        this.messageService.show(this.customMessage.otpTimeExpire, "error");
      }
    }, 1000);
  }

  clearTimer() {
    this.timeLeft = this.customMessage.otpLeftTime;
    this.otpBtnDisabled = false;
    this.otpForm.reset();
    clearInterval(this.subscribeTimer);
  }

  verifyOTP(
    formDirective1: FormGroupDirective,
    formDirective2: FormGroupDirective
  ) {
    this.otpFromDirective = formDirective2;
    this.validatePolicyFromDirective = formDirective1;

    const entity = {
      otp: this.otpForm.value.otp,
      mobileNumber: this.mobileNumber
    };

    this.otpService.otpValidation(entity)
      .subscribe({
        next: (res: ResponseMessage<any>) => {
          if (res.responseMessageStatus == ResponseMessageStatus.Ok) {
            this.clearTimer();
            this.otpFlag = false;
            this.getInformation();
            this.resetFromSettings();
          }
          else {
            if (res.responseMessageStatus == ResponseMessageStatus.OtpTryLimitExceeded) {
              this.resetFromSettings();
            }
            this.messageService.show(res.msg, 'error');
          }
        },
        error: (err) => {
          this.messageService.show(err.error.detail, 'error');
        },
      });
  }

  getMobileNumber(data: any) {
    this.newCaseApprovalService.getEnrol(this.groupPolicyId, data.certificateNo, data.birthYear)
      .subscribe(enrol => {
        if (enrol != null) {
          this.enrol = enrol;
          this.enrolId = enrol.id;
          this.mobileNumber = this.enrol.mobileNumber;
          const entity = {
            mobileNumber: this.mobileNumber,
            groupPolicyId: this.groupPolicyId,
            certificateNo: data.certificateNo
          };
          this.generateOtpViaMobileNumber(entity);
        }
      }, err => {
        this.messageService.show(err.error.message, "error");
        this.otpBtnDisabled = false;
      });
  }

  generateOtpViaMobileNumber(entity) {
    this.otpService.generateOtp(entity)
      .subscribe({
        next: (res: ResponseMessage<string>) => {
          if (res.responseMessageStatus == ResponseMessageStatus.Ok) {
            this.hashMobileNumber = res.data;
            this.otpFlag = true;
            this.isOtpGenerate = !this.isOtpGenerate;
            this.startTimer();
          }
          else {
            this.messageService.show(res.message, 'error');
            this.otpBtnDisabled = false;
          }
        },
        error: (err) => {
          this.messageService.show(err.error.message, 'error');
          this.otpBtnDisabled = false;
        },
      });
  }

  resetFromSettings() {
    if (this.otpFromDirective != null) {
      this.otpFromDirective.resetForm();
    }
    this.otpForm.reset();
    this.otpFlag = false;
    this.otpBtnDisabled = false;
    this.timeLeft = this.customMessage.otpLeftTime;
    this.isOtpGenerate = false;
  }

  enableOnlineGenerateInputTab() {
    this.isDocumentUploadPage = false;
  }

  getCurrentDate(): string {
    this.today.setDate(this.today.getDate());
    return this.today.toISOString().split('T')[0];
  }

  getDieaseName = (value: number): string => {
    const dieaseObj = this.diseaseList.find((diease: any) => diease.id === value);
    return dieaseObj ? dieaseObj.name : '';
  }

  isNumber(value) { return typeof value === 'number'; }

  private _filter(value: string): string[] {
    if (value && !this.isNumber(value)) {
      const filterValue = value.toLowerCase();
      return this.diseaseList.filter(option => option.name.toLowerCase().includes(filterValue));
    } else {
      return this.diseaseList;
    }
  }

  isOpPerDisabilityProduct() {
    const { productId, diseaseId } = this.diseaseDetailForm.value;
    const product = this.productList.find(e => e.id == productId);

    if (product && product.code == productCodes.OutPatient_Per_Disability && this.isOpProduct) {
      return true;
    }
    return false;
  }
}


